import React, { useEffect, useState } from 'react';
import events from './model';

const EventsComponent = (props) => {
  const { websiteDetails } = props;
  const [eventNumber, setEventNumber] = useState(websiteDetails.eventNumber || 1);
  const [isOwner, setIsOwner] = useState(websiteDetails.isOwner || false);

  useEffect(() => {
    setEventNumber(websiteDetails.eventNumber || 1);
    setIsOwner(websiteDetails.isOwner);
  }, [websiteDetails]);

  const EventComponent = events[eventNumber];
  return (
    <div>
      {EventComponent ? <EventComponent {...props} /> : <> </>}
      {isOwner && (
        <div>
          <button onClick={() => setEventNumber(eventNumber - 1 > 0 ? eventNumber - 1 : 1)}> - </button>
          <span>Version {eventNumber}</span>
          <button onClick={() => setEventNumber(events[eventNumber + 1] ? eventNumber + 1 : eventNumber)}> + </button>
        </div>
      )}
    </div>
  );
};

export default EventsComponent;
